import $ from 'jquery';
import attachSelect2 from 'select2';

function initRecoveryCountry() {
    const country = document.querySelector('.almc-recovery-checkout #billing_country');
    if (!country) return;

    // Porto may provide a chainable placeholder. Register the real plugin on
    // this bundle's jQuery instance before creating the searchable control.
    if (!$.fn.select2?.amd) {
        delete $.fn.select2;
        attachSelect2(window, $);
    }
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const countryCodes = new Set(Array.from(country.options, option => normalize(option.value)));
    $(country).select2({
        width: '100%',
        minimumResultsForSearch: 0,
        dropdownParent: $(country.closest('.form-field')),
        language: { noResults: () => country.dataset.noResults },
        matcher(params, data) {
            const query = normalize((params.term || '').trim());
            if (countryCodes.has(query)) return normalize(data.id || '') === query ? data : null;
            return !query || normalize(`${data.text} ${data.id}`).includes(query) ? data : null;
        },
    });
    $(country).on('change.almcRecovery', event => {
        // Select2 dispatches a jQuery event; the checkout listens natively.
        if (!event.originalEvent) country.dispatchEvent(new Event('change', { bubbles: true }));
    });
    $(country).on('select2:open', () => {
        const search = country.closest('.form-field').querySelector('.select2-search__field');
        if (search) {
            search.setAttribute('aria-label', country.dataset.searchLabel);
            search.setAttribute('placeholder', country.dataset.searchLabel);
            search.focus();
        }
    });
    const sync = () => $(country).trigger('change.select2');
    document.addEventListener('almc:registration-restored', sync);
    document.addEventListener('almc:payment-order-ready', sync);
    document.addEventListener('almc:billing-edit-ready', () => {
        sync();
        $(country).select2('open');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecoveryCountry);
} else {
    initRecoveryCountry();
}
